import { INVENTORY_CATEGORIES } from '../../utils/enums';

// Fixed-order categorical palette (validated for CVD-safe adjacent separation and
// contrast via the dataviz skill's validator — never reorder or cycle these).
export const CATEGORY_META = {
    [INVENTORY_CATEGORIES.BEVERAGES]: { label: 'Beverages', hex: '#2a78d6' },
    [INVENTORY_CATEGORIES.PAPER_STATIONERY]: { label: 'Paper & Stationery', hex: '#1baf7a' },
    [INVENTORY_CATEGORIES.CLEANING]: { label: 'Cleaning', hex: '#eda100' },
    [INVENTORY_CATEGORIES.KITCHENWARE]: { label: 'Kitchenware', hex: '#008300' },
    [INVENTORY_CATEGORIES.EQUIPMENT]: { label: 'Equipment', hex: '#4a3aa7' },
    [INVENTORY_CATEGORIES.OTHERS]: { label: 'Others', hex: '#e34948' },
};

// IN / OUT / BREAKAGE trend-line colors — validated to clear CVD separation together
// (brand orange next to a status green failed the check; blue swapped in cleanly).
export const TRANSACTION_TYPE_META = {
    in: { label: 'Stock In', hex: '#2a78d6' },
    out: { label: 'Stock Out', hex: '#C2571A' },
    breakage: { label: 'Breakage', hex: '#d03b3b' },
};

export const UNIT_SUGGESTIONS = ['Packets', 'Reams', 'Rolls', 'Boxes', 'Pieces', 'Jars', 'Bottles', 'Cartons', 'Kg', 'Litres'];

// Unit of measure is optional (some items, like glasses, are just counted) — these
// keep quantity + unit displays from showing a trailing space or "(  )" when it's blank.
export const formatQty = (qty, unit) => (unit ? `${qty} ${unit}` : `${qty}`);
export const unitLabel = (base, unit) => (unit ? `${base} (${unit})` : base);

const getFileNameFromHeader = (headerValue) => {
    if (!headerValue) return null;
    const match = headerValue.match(/filename="?([^";]+)"?/i);
    return match ? match[1] : null;
};

// Saves an axios blob response (responseType: 'blob') as a downloaded file —
// same approach as Settings > CSV Tools.
export const downloadCsvResponse = (response, fallbackFileName) => {
    const fileName = getFileNameFromHeader(response?.headers?.['content-disposition']) || fallbackFileName;
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};
